module.exports = __webpack_public_path__ + "img/featur_5.8502e4d7.jpg";